import React, { Fragment } from 'react';
import { parse, stringify } from 'flatted';
import cmsData from 'Lib/cmsData';
import fetchProgramList from 'Lib/fetchProgramList';
import { Router } from '../routes';
import Hero from '../components/home/hero';
import Programs from '../components/home/programs';
import Purpose from '../components/home/purpose';
import Impact from '../components/impact';
import Partners from '../components/home/partners';
import Content3Up from '../components/content-3-up';
import Connect from '../components/home/connect';
import CountryModal from '../components/home/country-modal';
import withYouTubeModal from '../components/with-youtube-modal';
import Seo from '../components/seo';

class Home extends React.PureComponent {

  static async getInitialProps({ req, query }) {
    const { region: regionQuery } = query;
    const userRegion = req ? req.userCountry : undefined;
    const initialRegionModal = !!req && !regionQuery && ['NZ', 'AU', 'PH'].indexOf(userRegion) !== -1;
    const contentParams = {
      content_type: 'home',
      include: 3,
      'fields.region': regionQuery ? regionQuery.replace(/^\D/, l => l.toUpperCase()) : 'US',
    };

    const data = await cmsData(contentParams);

    const [programList, cwcList] = await Promise.all([
      fetchProgramList('/v1/programs', data, 'featuredPrograms'),
      fetchProgramList('/v1/cwcs', data, 'featuredCwcProjects'),
    ]);

    const flatData = data && data[0] ? stringify(data[0]) : null;

    return { userRegion, regionQuery, initialRegionModal, data: flatData, programList, cwcList };
  }

  state = {
    regionModal: this.props.initialRegionModal,
  }

  regionSubmit = (e, region) => {
    e.preventDefault();

    this.setState({
      regionModal: false,
    });

    if (region !== this.props.regionQuery) {
      Router.replaceRoute(region);
    }
  }

  render() {
    const { programList, cwcList } = this.props;
    const data = this.props.data && parse(this.props.data);

    let programArray = programList && programList.length > 0 ? [...programList] : [];

    if (cwcList && cwcList.length > 0) {
      programArray = [...programArray, ...cwcList];
    }

    return (
      <Fragment>
        <Seo seo={data.fields.seo} />

        {this.state.regionModal &&
          <CountryModal
            regionSubmit={this.regionSubmit}
            userRegion={this.props.userRegion}
          />
        }

        <main aria-hidden={!!this.state.regionModal}>
          <Hero
            playHomeVideo={this.props.playHomeVideo}
            leftHeading={data.fields.leftHeading}
            rightHeading={data.fields.rightHeading}
            videos={data.fields.leftHeroVideo}
            modalVideo={data.fields.heroModalVideo}
            heroImage={data.fields.heroImage}
          />
          <Programs
            subheading={data.fields.programsSubheading}
            title={data.fields.programsTitle}
            copy={data.fields.programsCopy}
            programList={programArray}
          />
          <Content3Up
            title={data.fields.getInvolvedHeading}
            intro={data.fields.getInvolvedContent}
            contentBlocks={data.fields.getInvolvedBlock}
            home
            portraitImg
          />
          <Purpose
            subheading={data.fields.purposeSubheading}
            title={data.fields.purposeHeading}
            largeText={data.fields.purposeLargeText}
            subTitle={data.fields.purposeSubtitle}
            content={data.fields.purposeContent}
            images={data.fields.purposeImageGroup}
            carousel={data.fields.purposeCarousel}
          />
          <Impact
            data={data.fields.impactStats}
          />
          <Partners
            subheading={data.fields.partnersSubheading}
            title={data.fields.partnersTitle}
            partnerList={data.fields.featuredPartners}
          />
          <Connect
            title={data.fields.connectTitle}
            images={data.fields.connectedPhotos}
          />
        </main>
      </Fragment>
    );
  }
}

export default withYouTubeModal(Home);
